module.exports = __webpack_public_path__ + "static/media/card-game-record-btn.3f904a7c.png";